import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
export function SolutionSection() {
  const features = ['Soporte en tiempo real vía WhatsApp', 'Alineado con requisitos del Ministerio de Salud', 'Proceso guiado paso a paso'];
  return <section className="py-20 bg-slate-50" data-id="element-317">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-318">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-319">
          <div className="w-full lg:w-1/2" data-id="element-320">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative" data-id="element-321">
              <div className="absolute inset-0 bg-blue-200 rounded-3xl transform rotate-3" data-id="element-322"></div>
              <div className="relative bg-white p-8 rounded-3xl shadow-xl border border-blue-100" data-id="element-323">
                <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6 mx-auto lg:mx-0" data-id="element-324">
                  <ShieldCheck className="w-8 h-8 text-[#1e3a5f]" data-id="element-325" />
                </div>
                <h3 className="text-2xl font-bold text-[#1e3a5f] mb-4 text-center lg:text-left" data-id="element-326">
                  JAZUGA
                </h3>
                <p className="text-gray-600 mb-6 text-center lg:text-left" data-id="element-327">
                  Líderes en el mercado de GAS LP en Costa Rica.
                </p>
                <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-328">
                  <motion.div className="h-full bg-[#f59e0b]" initial={{
                  width: '0%'
                }} whileInView={{
                  width: '100%'
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} data-id="element-329" />
                </div>
                <p className="text-right text-xs text-gray-500 mt-2" data-id="element-330">
                  Progreso automatizado
                </p>
              </div>
            </motion.div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-331">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-332">
              <span className="text-[#f59e0b] font-bold tracking-wider uppercase text-sm" data-id="element-333">
                La Nueva Forma de Certificar
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mt-2 mb-8" data-id="element-334">
                Presentamos: Certificación LP Express
              </h2>

              <ul className="space-y-4" data-id="element-335">
                {features.map((feature, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="flex items-center gap-3" data-id="element-336">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-337">
                      <Check className="w-4 h-4 text-green-600" data-id="element-338" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-339">{feature}</span>
                  </motion.li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}